function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  stroke: "currentColor",
  strokeWidth: 2,
  fill: "transparent"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M12.1 5.94c1.24 0 2.24.28 3 .83.77.54 1.15 1.3 1.15 2.28 0 1.02-.31 1.81-.93 2.36a4.3 4.3 0 01-2.47 1l-.05 1.81h-1.84l-.04-2.72a6.1 6.1 0 002.52-.72c.5-.35.76-.83.76-1.46 0-.52-.2-.94-.58-1.24-.37-.3-.92-.45-1.65-.45-.72 0-1.3.2-1.75.6-.44.4-.7.94-.77 1.65l-1.78-.84c.19-.94.66-1.69 1.42-2.25a4.96 4.96 0 013-.85zm-.22 9.67c.4 0 .73.12.97.36.24.22.36.53.36.91 0 .4-.12.71-.36.94-.24.23-.56.34-.97.34-.42 0-.75-.11-1-.34a1.23 1.23 0 01-.35-.94c0-.38.12-.69.36-.91.25-.24.58-.36.99-.36z"
});

var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.f3b801fd.svg";
export { ForwardRef as ReactComponent };